import { useContext, useEffect } from 'react';
import { useRouter } from 'next/router';
import { faro } from '@grafana/faro-react';
import initFaro, { setFaroUser } from '@/lib/faro';
import { UserDetailsContext } from '@/modules/RegisterLayout/contexts/UserDetailsContextProvider';
const FaroInitializer = () => {
  const router = useRouter();
  const {
    user
  } = useContext(UserDetailsContext);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    initFaro();
    if (user?.id) {
      setFaroUser({
        id: user.id,
        email: user.email
      });
    }
  }, [user?.id, user?.email]);
  useEffect(() => {
    const handleRouteChange = () => faro?.api?.setView({
      name: router.pathname
    });
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => router.events.off('routeChangeComplete', handleRouteChange);
  }, [router.events, router.pathname]);
  return null;
};
export default FaroInitializer;